import { Button, ButtonsGroup, Input, Modal, ModalProps, Space, Text, useModal } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useRejectReceiptForm } from '../../hooks/useRejectReceiptForm'

interface NormalRejectionModalProps extends ModalProps {
  attachmentId?: string
  onSuccess?: () => void
}

export const OtherMarketEInvoiceRejectionModal = ({
  attachmentId,
  onSuccess,
  ...modalProps
}: NormalRejectionModalProps) => {
  const { t } = useTranslation()
  const { close } = useModal(modalProps.id)

  const {
    Form,
    FormItem,
    submitForm,
    isProcessing: isRejecting,
    isOrganizationLoading,
  } = useRejectReceiptForm({
    attachmentId,
    onSuccess: () => {
      close()
      onSuccess?.()
    },
  })

  return (
    <Modal size="s" closable {...modalProps}>
      <Modal.Header title={t('receipts.modal.reject_e_invoice.title')} />
      <Modal.Body>
        <Form>
          <Text colorVariant="secondary">{t('receipts.modal.reject.other.market.e_invoice.message')}</Text>
          <Space />
          <FormItem
            name="reason"
            render={({ field }) => (
              <Input {...field} placeholder={t('receipts.modal.reject_e_invoice.reason_placeholder')} />
            )}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button variant="text" onClick={close}>
            {t('cancel')}
          </Button>
          <Button
            onClick={submitForm}
            disabled={isRejecting || isOrganizationLoading}
            loading={isRejecting}
            color="danger"
          >
            {t('receipts.modal.reject_e_invoice.button')}
          </Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
